var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Grid } from '../../shared/grid/grid';
import React, { useEffect, useState } from 'react';
import { services } from '../../../shared';
import { Container, FormSelect, Heading, PageHeading, Section } from '../../shared';
import { Redirect } from 'react-router-dom';
import { BrokerStatus } from '../../../shared/types/enums';
export var MaintenancePage = function () {
    var _a = useState([]), userList = _a[0], setUserList = _a[1];
    var _b = useState(1), pageNo = _b[0], setPageNo = _b[1];
    var _c = useState(false), redirect = _c[0], setRedirect = _c[1];
    var _d = useState(''), title = _d[0], setTitle = _d[1];
    var _e = useState([]), statuses = _e[0], setStatuses = _e[1];
    var _f = useState('Id'), sortColumn = _f[0], setSortColumn = _f[1];
    var _g = useState('Desc'), sortOrder = _g[0], setSortOrder = _g[1];
    var pageSize = 10;
    var columns = [
        {
            id: 'userName',
            description: 'User name',
        },
        {
            id: 'name',
            description: 'Name',
        },
        {
            id: 'telephone',
            description: 'Phone number',
        },
        {
            id: 'jobTitle',
            description: 'Job Title',
        },
        {
            id: 'status',
            description: 'Status',
            render: function (column, row) {
                return React.createElement(FormSelect, { id: row.id, options: statuses, value: row.statusId, changeHandler: changeStatus });
            },
        },
    ];
    var changeStatus = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!confirm('Are you sure you want to update the status of this user?')) return [3 /*break*/, 3];
                    return [4 /*yield*/, services.updateUserStatus(Number(e.currentTarget.id), Number(e.currentTarget.selectedOptions[0].value))];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, fetchPageData(pageNo, pageSize)];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var fetchUsers = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, allowedStatus, broker, text;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = setUserList;
                    return [4 /*yield*/, services.getAllUsers(1, pageSize, sortColumn, sortOrder)];
                case 1:
                    _a.apply(void 0, [(_b.sent()).data]);
                    return [4 /*yield*/, services.getUserStatuses()];
                case 2:
                    allowedStatus = (_b.sent()).data.filter(function (status) {
                        return [BrokerStatus.Active, BrokerStatus.Pending, BrokerStatus.SuperUser, BrokerStatus.Inactive].includes(parseInt(status.value));
                    });
                    setStatuses(allowedStatus);
                    return [4 /*yield*/, services.getBroker()];
                case 3:
                    broker = (_b.sent()).data;
                    text = broker.organisationUniqueIdentifier === null
                        ? ''
                        : '- Organisation Identifier ' + broker.organisationUniqueIdentifier;
                    setTitle(text);
                    if (broker.superUser != true) {
                        setRedirect(true);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var fetchPageData = function (pageNumber, pageSize) { return __awaiter(void 0, void 0, void 0, function () {
        var list;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setPageNo(pageNumber);
                    return [4 /*yield*/, services.getAllUsers(pageNumber, pageSize, sortColumn, sortOrder)];
                case 1:
                    list = (_a.sent()).data;
                    setUserList(list);
                    return [2 /*return*/, list];
            }
        });
    }); };
    var fetchSortedData = function (column, order) { return __awaiter(void 0, void 0, void 0, function () {
        var users;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setSortOrder(order);
                    setSortColumn(column.id);
                    return [4 /*yield*/, services.getAllUsers(1, pageSize, column.id, order)];
                case 1:
                    users = (_a.sent()).data;
                    setUserList(users);
                    return [2 /*return*/, users];
            }
        });
    }); };
    useEffect(function () {
        fetchUsers();
    }, []);
    if (redirect) {
        return React.createElement(Redirect, { to: "/" });
    }
    return (React.createElement("section", null,
        React.createElement(PageHeading, { headingLevel: 2, title: "Maintenance", mb: 6, icon: "wrench" }),
        React.createElement(Container, null,
            React.createElement(Section, { headerChildren: React.createElement(Heading, { level: 'h2', title: 'Broker Maintenance ' + title }) },
                React.createElement(Grid, { rowData: userList, columns: columns, noRowsMessage: "No existing users", disablePaging: false, sortRows: fetchSortedData, gotoPage: fetchPageData, pageSize: pageSize })))));
};
